import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from './../../services/common.service';
import { UserService } from './../../services/user.service';
import { EncrDecrService } from '../../services/encr-decr.service';
import { ProfessionalService } from './../../services/professional.service';
import { NgIf } from '@angular/common';
// import { IMultiSelectOption, IMultiSelectTexts, IMultiSelectSettings } from 'angular-2-dropdown-multiselect';


declare var $: any;

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {

  modalRef: any = BsModalRef;
  config: any = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  };
  user_id: any = 0;
  company_id: any = 0;
  APIKEY: any = 0;
  notification: number;
  editUserForm: FormGroup;
  submitted = false;
  role_list: any = '';
  edit_userid: number = 0;
  imagePath: any = 'assets/images/users/profile_pic.png';
  dropdownList = [];
  // dropdownSettings = {};
  selectedItems: any = {};
  customer_per: any = '';
  customer_list: any = {};
  customer_list_event: boolean = false;
  btnDisable: boolean = false;
  model = {};
  professional_id: any;
  dropdownList1: { id: number; itemName: string; }[];
  selectedItems1: { id: number; itemName: string; }[];
  dropdownSettings1: { showCheckbox: boolean; singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; classes: string; };
  pro_id: any;
  pro_id_check: number;
  pro_id_not_exist: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private _User: UserService,
    private _Common: CommonService,
    private toastr: ToastrService,
    private _router: Router,
    private _activatedroute: ActivatedRoute, private EncrDecr: EncrDecrService,
    private _professional: ProfessionalService, private modalService: BsModalService,) { }

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this.setFormValue();
    this._activatedroute.params.subscribe(params => {
      this.edit_userid = params['id'];
    });
    const data = {
      APIKEY: this.APIKEY,
      company_id: this.company_id,
    }

    this.editUserForm.controls['country_code'].setValue('+1', { onlySelf: true });
    this.editUserForm.controls['status'].setValue('active', { onlySelf: true });
    this.getRoleList(data);
    this.getCustomerLis(data, 'normal');
    // this.getCustomerListDrop();

    this.dropdownList1 = [];
    this.selectedItems1 = [];
    this.dropdownSettings1 = {
      showCheckbox: false,
      singleSelection: true,
      text: "Select Professional",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: " "
    };

  }

  getCustomerLis(data, mode) {
    this._professional.getProfessionalList(data)
      .subscribe(
        res => {
          if (res.data.professional_id == '0') {
            res.data.professional_id = '';
          }

          var i = 0;
          for (let item of res.data) {
            if (item['pro_id'] != item['item_id']) {
              this.dropdownList1.push({ 'id': item['item_id'], 'itemName': item['item_text'] });
            }
            i++;
          }
        },
      );
  }

  getRoleList(data) {
    this._Common.getRoleList(data)
      .subscribe(
        res => {
          this.role_list = res.data;
        },
      );
  }

  setFormValue() {
    this.editUserForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: [''],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      country_code: [''],
      phone: [''],
      alter_phone: [''],
      notification: [''],
      role: ['', Validators.required],
      note: [''],
      status: [''],
      profile_pic: [''],
      id: ['0'],
      professional_id: [[]],
    });
  }

  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => {
        this.imagePath = event.target.result;
      }
      const file = event.target.files[0];
      this.editUserForm.get('profile_pic').setValue(file);
    }
  }
  // convenience getter for easy access to form fields
  get f() { return this.editUserForm.controls; }

  onSubmit() {
    this.btnDisable = true;
    this.submitted = true;

    if (this.customer_list_event == false) {
      this.editUserForm.controls['professional_id'].setValue('0');
    }
    if (this.customer_list_event == true) {
      for (let item_id of this.selectedItems1) {
        this.pro_id_check = item_id['id'];
      }

      if (this.pro_id_check) {
      } else {
        this.pro_id_not_exist = true;
        return;
      }
    }
    // stop here if form is invalid
    if (this.editUserForm.invalid) {
      return;
    }
    //alert('SUCCESS!! :-)')
    const formData = new FormData();
    formData.append('first_name', this.editUserForm.get('first_name').value);
    formData.append('last_name', this.editUserForm.get('last_name').value);
    formData.append('email', this.editUserForm.get('email').value);
    formData.append('password', this.EncrDecr.set(localStorage.getItem('key'), this.editUserForm.get('password').value));

    // formData.append('password', this.editUserForm.get('password').value);
    formData.append('country_code', this.editUserForm.get('country_code').value);
    formData.append('phone', this.editUserForm.get('phone').value);
    formData.append('alter_phone', this.editUserForm.get('alter_phone').value);
    formData.append('note', this.editUserForm.get('note').value);
    formData.append('role', this.editUserForm.get('role').value);
    formData.append('status', this.editUserForm.get('status').value);
    formData.append('profile_pic', this.editUserForm.get('profile_pic').value);
    formData.append('customer_per', this.customer_per);

    formData.append('user_id', this.user_id);
    formData.append('company_id', this.company_id);
    formData.append('APIKEY', this.APIKEY);
    if (this.customer_list_event == false) {
      formData.append('professional_id', this.editUserForm.get('professional_id').value);
    }

    if (this.customer_list_event == true) {
      for (let item_id of this.selectedItems1) {
        this.pro_id = item_id['id'];
      }
      formData.append('professional_id', this.pro_id);
    }

    this._User.addUser(formData).subscribe(
      res => {
        if (res.status == true) {
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/user/user-list/active');
          });
        }
        else {
          this.toastr.error(res.message, 'Error');
        }
      }
    );
  }

  public onChange(event): void {
    const newVal = event.target.value;
    var splitted = newVal.split("-", 3);
    var name = splitted[1];
    if (name === 'Professional User') {
      this.customer_list_event = true;
    }
    else {
      this.customer_list_event = false;
    }
  }

  public notify(value) {
    this.model["notification"] = value;
  }

  onlyAlpha_numberic(evt) {

    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46)
      return true;
    return false;
  }

  onChangeProfessional(pro_id: any) {
    this.professional_id = pro_id;
  }

  openModal(template: TemplateRef<any>) {
    $(function () {
      $(".select2").select2({
        placeholder: "--Select--"
      });
    });

    this.modalRef = this.modalService.show(template, this.config);
  }

  onItemSelect(item: any) {
    const datapro = {
      APIKEY: this.APIKEY,
      company_id: this.company_id,
      professional_id: item.id,
    }
    this.pro_id_not_exist = false;
    this.getProfessional_data(datapro);
  }

  getProfessional_data(datapro) {
    this._professional.getprofessionaldata(datapro)
      .subscribe(
        res => {
          this.editUserForm.get('email').setValue(res.data.email);
          this.editUserForm.get('phone').setValue(res.data.phone);
          this.editUserForm.get('first_name').setValue(res.data.professional_name);
          if (res.data.status == 'Active') {
            this.editUserForm.get('status').setValue('active');
          } else {
            this.editUserForm.get('status').setValue('inactive');
          }
        },
      );
  }


}
